import React, { Component } from 'react';
import { Card, Form, Badge } from 'react-bootstrap';
import ThumbnailImage from './ThumbnailImage';
import ThumbnailImageCentered from '../Attendees/ThumbnailImageCentered';
import Utils from '../Utils';
import SpeakerFlag from './SpeakerFlag';
import Storage from '../Storage';
import './style.css';
import { connect } from 'react-redux';
const getSpeakerTitle = (speaker,locale)=>{
  let titleRet = '';
  switch(locale){
 
    case "en":
      titleRet = speaker.title_EN != "" ? speaker.title_EN : speaker.title;
      break;
    case "es":
      titleRet = speaker.title_ES != "" ? speaker.title_ES : speaker.title;
      break;
    case "pt":
      titleRet = speaker.title_PT != "" ? speaker.title_PT : speaker.title;
      break;
    case "fr":
      titleRet = speaker.title_FR != "" ? speaker.title_FR : speaker.title;
      break;
    default:
      titleRet = speaker.title;
 }
 if (titleRet?.length > 60){
  titleRet = titleRet.substring(0,60) + "...";
 }
 return titleRet;
}
const SpeakerItemInList = ({ speaker,role, locale }) => {
  return (
    <div className="speakerItemListWrapper">
        
        <ThumbnailImageCentered
        rounded
        small
        src={Utils.getProfilePictureOrUnknown(speaker.pictureId)}
        alt="profile"
        className="m-4 "
        />
        <div className="activitySpeakerFlagAndNameWrapper">
            <SpeakerFlag key={speaker.id} countryName= {speaker.country} />
            <div className="activitySpeakerNameContainer">
            {role != "" ? <span className="speaker-role">{role}</span>  :null}
                <h5><span className="programme_speaker_treatment" >{speaker.treatment + ' '}</span>
                { Storage.getShowPeopleLastNameFirst() ?
                      <><span className="programme_speaker_firstname" >{speaker.firstName + ' '}</span><span className="programme_speaker_lastname" >{speaker.lastName }</span></>
                  :
                  <><span className="programme_speaker_lastname" >{speaker.lastName + ', '}</span><span className="programme_speaker_firstname" >{speaker.firstName }</span></>

                }
                </h5>  
                <h6>{getSpeakerTitle(speaker,locale)}</h6>
               
            </div>
        </div>
    </div>
  );
};
const mapStateToProps = state => {
  return { 
    locale: state.settings.locale}
}
export default connect(mapStateToProps,null)(SpeakerItemInList)
/* React.memo detail : https://reactjs.org/docs/react-api.html#reactpurecomponent  */
// export default React.memo(SpeakerItemInList);